import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Order from '../views/Order.vue'
import Details from '../views/Details.vue'
import Alert from "../views/Alert";
const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: 'index.meta.title',
      keywords:"index.meta.keywords"
    },
    component: Home
  },
  {
    path: '/order',
    name: 'Order',
    meta: {
      title: 'order.meta.title'
    },
    component: Order
  },
  {
    path: '/details',
    name: 'Details',
    meta: {
      title: 'details.meta.title'
    },
    component: Details
  },
  {
    path: '/alert',
    name: 'Alert',
    meta: {
      title: 'alert.meta.title'
    },
    component: Alert
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      title: '关于我们'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
